import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// local imports
import DragHereImage from '../../../assets/drag-here-image.png';
import { imageValidCheck, imageTypeCheck } from '../../../utils/utility-functions';
import trashIcon from '../../../assets/trash-icon.svg';
import dragActiveImage from '../../../assets/drag-active-image.png';
import CustomButton from '../../../components/atoms/Button';
import { productActions } from '../../../store/slices';


function DragAndDrop({title}) {
    const product = useSelector(state => state.product.product);
    const dispatch = useDispatch();
    const { image } = product;

    const inputRef = useRef();
    const [isDragActive, setIsDragActive] = useState(false);
    const [error, setError] = useState(null);

    const handleDragEnter = (src) => {
        dispatch(productActions.setImage(src))
    }

    //Drag & Drop Component Functions
    const browseFile = () => {
        inputRef.current.click();
    };
    const inputChange = (e) => {
        const file = e.target.files[0];
        imageTypeCheck(file, setError);
        imageValidCheck(file, 1000, 1000, handleDragEnter, setError);
    };

    // if user leave dragged file from DragArea
    const onDragLeave = (e) => {
        e.preventDefault(); // preventing from default behaviour
        e.stopPropagation(); // stops the event from being propagated through parent and child elements.
        console.log('File is outside of the div');
        setIsDragActive(false);
    };

    // if user Drag file Over DragArea
    const onDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Drag over');
        setIsDragActive(true);
    };

    // if user drop File on DropArea
    const onDragDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('File is dropped on div');
        setIsDragActive(false);

        // getting user select file and [0] means if user select multiple files we'll select only the first one
        const file = e.dataTransfer.files[0];

        imageTypeCheck(file, setError);
        imageValidCheck(file, 1000, 1000, handleDragEnter, setError);
    };

    return (
        <form className='product-right'>
            <h2>{title}</h2>
            <div
                className={`product-image-upload ${isDragActive ? 'product-image-upload-active' : ''}`} 
                draggable
                onDragOver={(e) => onDragOver(e)}
                onDragLeave={(e) => onDragLeave(e)}
                onDrop={(e) => onDragDrop(e)}
            >
                {isDragActive ? (
                    <div className='drag-active'>
                        <img src={dragActiveImage} alt='' />
                        <span className='drag-title'>Sürükle ve Ekle</span>
                    </div>
                ) : image ? (
                    <img
                        className='product-image-file-loader'
                        src={image}
                        alt=''
                    />
                ) : (
                    <>
                        <img src={DragHereImage} alt='drag-here-img' />
                        <p>Görsel dosyalarınızı buraya bırakın</p>
                        <span>
                            (PNG / jpeg / jpg formatlarında yüklediğiniz görsel 600x800
                            standartlarında ve en fazla 10 Mb boyutunda olmalıdır)
                        </span>
                    </>
                )}
            </div>
            {image || error ? (
                <span
                    className='product-trash-button'
                    onClick={() => {
                        handleDragEnter('');
                        setError('');
                    }}
                >
                    <img src={trashIcon} alt='trash-icon' />
                    Dosyayı Sil
                </span>
            ) : (
                <>
                    <CustomButton onClick={browseFile} title={'Dosya Seç'} size='md' />
                    <input
                        ref={inputRef}
                        onChange={(e) => inputChange(e)}
                        type='file'
                        hidden
                    />
                </>
            )}
            {error !== null ? <span className='error-message'>{error}</span> : ''}
        </form>
    );
}
export default DragAndDrop;
